<template>
  <div class="page flex-col">
    <div class="box_2 flex-row">
      <div class="group_3 flex-row justify-end">
        <img
          class="image_2"
          referrerpolicy="no-referrer"
          src="static/img/avatar/default/doctor4.png"
        />
        <div class="box_3 flex-col">
          <span class="text_3">{{currentUser && currentUser.dic_worker_name}}</span>
          <div class="text-wrapper_3 flex-row justify-between">
            <span class="text_4">{{currentUser && currentUser.dic_worker_section_name}}</span>
            <span class="text_5">{{currentUser && currentUser.dic_worker_worker_duty}}</span>
          </div>
        </div>
        <div class="group_5 flex-row justify-between"  @click="selectWard()">
          <span class="text_7">{{active_hospital_ward && active_hospital_ward.label}}</span>
          <i class="el-icon-arrow-right" style="font-size:18px;color:#ffffff;"></i>
        </div>
      </div>
    </div>
    <div class="group_6 flex-col">
      <div class="group_7 flex-col">
        <div class="list_2 flex-col"></div>
        <div class="text-wrapper_1 flex-col">
          <span class="text_1" @click="logoutbody">退出登录</span>
        </div>
      </div>
    <div class="group_8 flex-row justify-between">
      <vtabbar v-model="activeBottomTabItem">
          <vtabbaritem icon="bars" class="thumbnail_14 text-group_9">患者列表</vtabbaritem>
          <vtabbaritem icon="bars" class="thumbnail_14 text-group_9">患者转运</vtabbaritem>
          <vtabbaritem icon="comment-o" class="thumbnail_14 text-group_8">我的</vtabbaritem>
      </vtabbar>
    </div>
    </div>
    <vpopup v-model="showOperWard" round position="bottom">
        <vpicker show-toolbar :columns="OperWards" @confirm="selectOperWardConfirm" @cancel="cancelOperWard" />
    </vpopup>
  </div>
</template>
<script>
import { NavBar as vnavbar, Empty, Popup as vpopup, Tabbar as vtabbar, TabbarItem as vtabbaritem, Picker as vpicker, Button as vbutton, Dialog, Field as vfield, Icon as vicon, Tag as vtag } from 'vant'
import 'vant/lib/index.css'
import { mapGetters } from 'vuex'
export default {
    name: `MyInfo`,
    components: { vnavbar, Empty, vpopup, vpicker, vtabbar, vtabbaritem, vbutton, [Dialog.Component.name]: Dialog.Component, vfield, vicon, vtag },
    data() {
        return {
            showOperWard: false,
            activeBottomTabItem: 2
        }
    },
    computed: {
        ...mapGetters([`currentUser`, `hospital_ward_auth`, `active_hospital_ward`]),
        OperWards() {
            return _.map(this.hospital_ward_auth, hward => {
                return { text: hward.label, value: hward.value }
            })
        }
    },
    created() {
        this.$store.dispatch(`ADD_CURRENTUSER`).then(() => {
        })
    },
    mounted() {},
    methods: {
        selectWard() {
            this.showOperWard = true
        },
        selectOperWardConfirm(item) {
            this.showOperWard = false
            let selectedWard = {
                label: item.text,
                value: item.value,
                origion: item.value
            }
            this.$store.commit(`SET_ACTIVE_HOSPITAL_WARD`, selectedWard)
            sessionStorage.removeItem(`search`)
            this.$router.push({ path: `/m_baseinfo` }).catch(err => err)
        },
        cancelOperWard() {
            this.showOperWard = false
        },
        logoutbody() {
            Dialog.confirm({
                message: `确认退出`
            })
                .then(() => {
                    this.$router.replace(`/m_login`).then(() => {
                        sessionStorage.removeItem(`token`)
                        sessionStorage.removeItem(`search`)
                        sessionStorage.removeItem(`doctoken`)
                    })
                })
                .catch(() => {
                    // on cancel
                })
        }
    },
    watch: {
        hospital_ward_auth: function(newVlaue, oldValue) {
            if (this.hospital_ward_auth && this.hospital_ward_auth.length == 1) {
                let selectedWard = {
                    label: this.hospital_ward_auth[0].label,
                    value: this.hospital_ward_auth[0].value,
                    origion: this.hospital_ward_auth[0].value
                }
                this.$store.commit(`SET_ACTIVE_HOSPITAL_WARD`, selectedWard)
                this.$router.push({ path: `/m_baseinfo` }).catch(err => err)
            } else if (this.hospital_ward_auth && this.hospital_ward_auth.length > 1) {
                this.OperWards = _.map(this.hospital_ward_auth, hward => {
                    return { text: hward.label, value: hward.value }
                })
                this.showOperWard = true
            } else {
                Dialog.alert(`用户没有分配院区`, `提示信息`)
            }
        },
        activeBottomTabItem: function(newval, oldval) {
            if (newval == 0) {
                this.$router.push({ path: `/m_baseinfo` }).catch(err => err)
            }
            if (newval == 1) {
                this.$router.push({ name: `TransferList` }).catch(err => err)
            }
            if (newval == 2) {
                this.$router.push({ name: `MyInfo` }).catch(err => err)
            }
        }
    }
}
</script>
<style lang="less" scoped>
@import 'mobile_common.css';
.page {
  background-color: rgba(242, 242, 246, 1);
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding-top: 148px;
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
}

.group_6 {
  height: calc(100% - 148px);
}

.group_7 {
  margin-bottom: 54px;
  padding: 44px 16px 17px 16px;
}

.list_2 {
  height: 88px;
}

.image-text_7 {
  width: 60px;
}

.thumbnail_11 {
  width: 20px;
  height: 20px;
  margin: 2px 0 2px 0;
}

.text-group_7 {
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 16px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 24px;
}

.image-text_8 {
  width: 94px;
  margin: 3px 0 2px 156px;
}

.text-group_2 {
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 19px;
}

.thumbnail_12 {
  width: 7px;
  height: 13px;
  margin: 3px 0 3px 0;
}

.thumbnail_13 {
  width: 7px;
  height: 13px;
  margin: 6px 0 5px 243px;
}

.text-wrapper_1 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 4px;
  margin-top: 284px;
  padding: 12px 143px 11px 144px;
}

.text_1 {
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
  font-family: MicrosoftYaHei;
  font-weight: normal;
  text-align: center;
  white-space: nowrap;
  line-height: 19px;
}

.group_8 {
  // background-color: rgba(255, 255, 255, 1);
  // margin: 609px 0 0 -375px;
  padding: 10px 40px 9px 30px;
  bottom: 0;
  position: fixed;
}

.thumbnail_14 {
  width: 20px;
  height: 20px;
  align-self: center;
}

.text-group_8 {
  overflow-wrap: break-word;
  color: rgba(0, 150, 136, 1);
  font-size: 10px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  text-align: right;
  white-space: nowrap;
  line-height: 16px;
}

.image-text_10 {
  margin-left: 52px;
}

.thumbnail_15 {
  width: 20px;
  height: 20px;
  align-self: center;
}

.text-group_9 {
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 0.9);
  font-size: 10px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 16px;
}

.image-text_11 {
  margin-left: 61px;
}

.thumbnail_16 {
  width: 20px;
  height: 20px;
}

.text-group_10 {
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 0.9);
  font-size: 10px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 16px;
}

.image-text_12 {
  margin-left: 72px;
}

.thumbnail_17 {
  width: 20px;
  height: 20px;
}

.text-group_11 {
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 0.9);
  font-size: 10px;
  font-weight: normal;
  text-align: right;
  white-space: nowrap;
  line-height: 16px;
}

.box_2 {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 148px;
  background: url(/static/img/mobile/myinfo_h_bg.png)
    100% no-repeat;
  background-size: 100% 100%;
  padding: 9px 15px 120px 20px;
}

.text_8 {
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 15px;
  letter-spacing: -0.30000001192092896px;
  font-family: SFProText-Semibold;
  font-weight: 600;
  text-align: right;
  white-space: nowrap;
  line-height: 18px;
}

.thumbnail_18 {
  width: 17px;
  height: 11px;
  margin: 8px 0 0 219px;
}

.thumbnail_19 {
  width: 15px;
  height: 11px;
  margin: 7px 0 1px 5px;
}

.image_3 {
  width: 25px;
  height: 12px;
  margin: 7px 0 0 5px;
}

.group_3 {
  background-color: rgba(255, 255, 255, 1);
  border-radius: 6px;
  position: absolute;
  left: 16px;
  top: 74px;
  width: 100%;
  height: 102px;
  padding: 16px 0 15px 10px;
}

.image_2 {
  width: 60px;
  height: 60px;
  margin: 5px 0 6px 0;
}

.box_3 {
  margin-left: 10px;
}

.text_3 {
  overflow-wrap: break-word;
  color: rgba(51, 51, 51, 1);
  font-size: 18px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
  line-height: 25px;
  margin-right: 86px;
}

.text-wrapper_3 {
  width: 110px;
  margin: 4px 30px 0 0;
}

.text_4 {
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}

.text_5 {
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}

.text_6 {
  overflow-wrap: break-word;
  color: rgba(153, 153, 153, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
  margin-top: 2px;
}

.group_5 {
  width: 90px;
  background: url(/static/img/mobile/mobile_my_headerleft.png) 100% no-repeat;
  background-size: 100% 100%;
  margin: 19px 0 20px 33px;
  padding: 6px 7px 6px 14px;
}

.text_7 {
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 14px;
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
  line-height: 20px;
}

.thumbnail_20 {
  width: 5px;
  height: 9px;
  margin: 6px 0 5px 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Mobile/MyInfo.vue